// extracted by mini-css-extract-plugin
export default {"secondaryBtn":"secondary-button_secondaryBtn__WH3YW","secondaryBtnText":"secondary-button_secondaryBtnText__3fzTd","addSecondaryBtn":"secondary-button_addSecondaryBtn__WwHiu"};